import * as React from "react";
import { Image, IImageProps } from "@fluentui/react/lib/Image";
import { PrimaryButton } from "@fluentui/react/lib/components/Button/PrimaryButton/PrimaryButton";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import AppVersionInfo from "../../components/AppVersionInfo/AppVersionInfo";
import AppFeedback from "../../components/AppFeedback/AppFeedback";
import DecommissionDialog from "../DecommissionDialog/DecommissionDialog";
import VerhinderungAppNutzungDialog from "../VerhinderungAppNutzung/VerhinderungAppNutzungDialog";

class CpbxAppSettings extends React.Component {
    private imageProps: Partial<IImageProps> = {
        src: "/assets/logo-corner-big.svg"
    };

    private imagePropsMobile: Partial<IImageProps> = {
        src: "/assets/logo-corner-small.svg"
    };

    handleDoLogoutCbpx = (): void => {
        LocalCacheHelper.RemoveLocalCacheKeysForCbpxAll();
        window.location.reload();
    };

    state = {
    }

    render() {
        // faqHtmlOutput will be generated in componentDidMount
        // place other stuff (like version-info for footer here)
        return (
            <div className="cpbxContOuter ms-Grid cpbxContOuterAppSetting">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4 ms-xxl6 ms-xlPush8 ms-xxlPush6 cpbxContInner cpbxContInnerLogo">
                        <div className="cpbxBgLogoCont">
                            <Image className="cpbxBgLogo" {...this.imageProps} alt="TelekomLogo" />
                        </div>
                        <div className="cpbxBgLogoCont"><Image className="cpbxBgLogoMobile" {...this.imagePropsMobile} alt="TelekomLogo" /></div>
                    </div>
                    <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl8 ms-xxl6 ms-xlPull4 ms-xxlPull6 cpbxContInner">
                        <div className="cpbxHeader"><h1>Einstellungen</h1></div>
                        <div className="cpbxText"><p>Hier finden Sie eine Übersicht der Einstellungen Ihrer Telefonanlage mit CompanyFlex Cloud PBX.</p></div>
                        <div className="cpbxAppSettingGruppeTitle"><h2>Login-Status</h2></div>
                        <div className="cpbxAppSettingLogonInfo">
                            <div className="cpbxAppSettingText"><p>Angemeldet als:</p></div>
                            <div className="cpbxAppSettingUserName"><p>{LocalCacheHelper.getCurrentUserName()}</p></div>
                            <div className="cpbxAppSettingLogoutDiv">
                                <PrimaryButton text="Logout" allowDisabledFocus style={{ borderRadius: "8px" }} onClick={this.handleDoLogoutCbpx} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner cpbxFooter">
                        <div>
                            <AppVersionInfo />
                        </div>
                        <div className="cpbxFeedbackLink"><AppFeedback /></div>
                    </div>
                </div>
                <DecommissionDialog/>
                <VerhinderungAppNutzungDialog/>
            </div>
        );
    }
}

export default CpbxAppSettings;
